const PreventDefault = (callback) => {
	return (event) => {
		event.preventDefault();
		callback(event);
	};
};
export default PreventDefault;
